<template>
  <div
    :id="'restriktionen-badge-' + _uid"
    class="restriktionen-badge d-flex align-items-center justify-content-center"
    :style="{
      color: config.textColor,
      backgroundColor: config.bgColor,
      borderColor: config.borderColor,
    }"
  >
    <component :is="iconComponent" :size="16" class="restriktionen-badge__icon" />
    <span>{{ displayLabel }}</span>
    <span v-if="count > 0" class="restriktionen-badge__count">+{{ count }}</span>

    <!-- Hover mit den Details der Restriktionen des Tages -->
    <b-popover
      v-if="entries.length"
      :target="'restriktionen-badge-' + _uid"
      triggers="hover"
      placement="top"
      boundary="viewport"
      customClass="restriktionen-kalendertag-popover"
    >
      <RestriktionenKalendertagHover :entries="entries" />
    </b-popover>
  </div>
</template>

<script>
import RestriktionenKalendertagHover from './restriktionen-kalendertag-hover.vue';
import restriktionenTypMixin from './restriktionen-typ.mixin.js';

export default {
  name: 'RestriktionenBadgeComponent',
  mixins: [restriktionenTypMixin],
  components: {
    RestriktionenKalendertagHover,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    // Optionaler Zähler für weitere Restriktionen am selben Tag
    count: {
      type: Number,
      default: 0,
    },
    label: {
      type: String,
      default: null,
    },
    // Restriktionen des Tages für das Hover-Popover, ohne Einträge wird kein Popover gerendert
    entries: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    config() {
      return this.typeConfig(this.type);
    },
    iconComponent() {
      return this.config.icon;
    },
    displayLabel() {
      return this.label || this.config.label;
    },
  },
};
</script>

<style scoped>
.restriktionen-badge {
  width: 100%;
  height: 100%;
  gap: 8px;
  padding: 8px 10px;
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  font-size: 14px;
  line-height: 18px;
  font-weight: 600;
}

.restriktionen-badge__icon {
  flex-shrink: 0;
}

.restriktionen-badge__count {
  padding: 4px 8px;
  border-radius: var(--radius-sm);
  background-color: #0000001a;
  font-size: 12px;
  line-height: 14px;
}
</style>

<style>
.restriktionen-kalendertag-popover.popover {
  max-width: 380px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow-lg);
}

.restriktionen-kalendertag-popover .popover-body {
  padding: 16px;
}
</style>
